import React from "react";
import { Chip } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

const ListaCursosHabilitados = ({
  cursos,
  loading,
  cursoSeleccionado,
  onSelect,
}) => {
  if (loading) {
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );
  }

  if (!cursos?.length) {
    return (
      <div className="admin-muted-text-small mt-2">
        Este profesor no tiene cursos habilitados.
      </div>
    );
  }

  return (
    <div className="d-flex flex-wrap mt-2" style={{ gap: 8 }}>
      {cursos.map((item) => {
        const clave = `${item.idCursoPlanLector}-${item.instituto}-${item.curso}`;
        const activo =
          cursoSeleccionado &&
          String(cursoSeleccionado.idCursoPlanLector) ===
            String(item.idCursoPlanLector);
        return (
          <Chip
            key={clave}
            size="small"
            label={`${item.instituto} - ${item.curso}`}
            clickable={Boolean(onSelect)}
            onClick={onSelect ? () => onSelect(item) : undefined}
            variant={activo ? "default" : "outlined"}
            style={activo ? { background: "#5fbeaa", color: "#fff" } : undefined}
          />
        );
      })}
    </div>
  );
};

export default ListaCursosHabilitados;
